import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { STORAGE_KEYS } from "@/constants/storage";
import Button from "./Button";

function getStorageKey(pathname: string): string {
  if (pathname.includes("/specialist-profile/")) return STORAGE_KEYS.BACK_FROM_SPECIALIST_PROFILE;
  if (pathname.includes("/booking")) return STORAGE_KEYS.BACK_FROM_BOOKING;
  return STORAGE_KEYS.BACK_FROM_SPECIALIST_PROFILE;
}

interface BackButtonProps {
  /** Override the "from" label. When not provided, uses sessionStorage key for current page, or falls back to "Search Results" */
  label?: string;
  className?: string;
}

export function BackButton({ label, className = "" }: BackButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const storageKey = getStorageKey(location.pathname);
  const fromStorage =
    typeof window !== "undefined" ? sessionStorage.getItem(storageKey) : null;
  const from = fromStorage ?? "Search Results";
  const displayLabel = label ?? `Back to ${from}`;

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      navigate({ to: "/" });
    }
  };

  return (
    <Button
      variant="ghost"
      onClick={handleGoBack}
      className={`hover:bg-gray-100 -ml-2 text-gray-600 font-medium ${className}`.trim()}
    >
      <ArrowLeft className="mr-2 h-4 w-4" />
      {displayLabel}
    </Button>
  );
}
